import React, { useEffect } from "react"
import { observer } from "mobx-react"
import { MantineProvider } from "@mantine/core"
import { CodeHighlightAdapterProvider } from "@mantine/code-highlight"
import { AppWorkspaceContainer } from "./app/components/AppWorkspaceContainer"
import { AppWorkspaceContext, createdWorkspace } from "./app/stores/AppWorkspace"
import { highlightJsAdapter } from "./highlight"
import { orTheme } from "./theme"

export const AppContainer: React.FC = observer(() => {
  const workspace = createdWorkspace

  useEffect(() => {
    const onPopState = () => workspace.syncFromLocation()
    window.addEventListener("popstate", onPopState)
    return () => window.removeEventListener("popstate", onPopState)
  }, [workspace])

  return (
    <MantineProvider theme={orTheme} defaultColorScheme="light">
      <CodeHighlightAdapterProvider adapter={highlightJsAdapter}>
        <AppWorkspaceContext.Provider value={workspace}>
          <AppWorkspaceContainer />
        </AppWorkspaceContext.Provider>
      </CodeHighlightAdapterProvider>
    </MantineProvider>
  )
})
